export default class Formatter
{
    phone(phone = '', countryCode = '')
    {
        let number      = phone.substr(phone.length - 10, 10);
        let areaCode    = number.substr(0, 3);
        let firstThree  = number.substr(3, 3);
        let lastFour    = number.substr(-4, 4);
        let fullNumber  = ' ('  + areaCode  + ') ' + firstThree  + '-' + lastFour;

        if( countryCode ){
            fullNumber = '+' + countryCode + ' ' +  fullNumber
        }

        return  fullNumber;
    }

    phoneFromFullPhone(fullPhone)
    {
        fullPhone = fullPhone.replace(/[^0-9]+/g, '');
        let countryCode = '';
        let phone = '';
        if(fullPhone.length <= 10){
            phone = fullPhone;
        }else{
            phone = fullPhone.substr(-10);
            countryCode = fullPhone.substr(0, fullPhone.length - 10);
        }
        return this.phone(phone, countryCode);
    }

    money(input)
    {
        let val   = input.toLocaleString();
        let segs  = val.split('.');
        let end   = '';
        if( segs.length === 1 )
            end = '.00';
        if( segs.length === 2 ){
            if( segs[1].length === 1)
                end = '0'
        }

        return val + end; 
    }

    flattenErrors(errorObj)
    {
        let errors = {};
        for(let k in errorObj){
            errors[k] = errorObj[k][0];
        }
        return errors;
    }

    shortText(text, maxLength, elipsis = false)
    {
        text = text + '';
        if(text.length <= maxLength){
            return text;
        }

        let newText = text.substring(0, maxLength);
        if(elipsis){
            newText = newText.substring(0, newText.length - 3) + '...';
        }

        return newText;
    }
}